import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AgentPage from "@/pages/AgentPage";

export const Route = createFileRoute("/agent")({
  head: () => routeHead('AGAPE AI Agent — Try the Assistant', META_DESCRIPTIONS.agent.en, '/agent'),
  component: AgentPage,
});
